import _find from 'lodash/find'
import _result from 'lodash/result'
import _map from 'lodash/map'
import _get from 'lodash/get'
import React, { createRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DisableSectionByPermissionWrapper } from '../hoc'

import { RouteLeavingGuard } from '../_library/RouteLeavingGuard'
import Card from '../_library/Card'
import ImportGuestsForm from './guesttickets/ImportGuestsForm'
import GuestTicketDelegations from './guesttickets/Delegations'
import GuestTicketsIssued from './guesttickets/GuestTicketsIssued'
import TimeSlotGuestsForm from './guesttickets/TimeSlotGuestsForm'

// actions
import { FETCH_EVENT_TICKETS, FETCH_EVENT_TABLES } from '../../_common/redux/tickets/actions'
import { UPLOAD_GUESTTICKETS, GET_SEAT_MAP_DATA } from '../../_common/redux/guesttickets/actions'
import { FETCH_EVENT_ADDONS } from '../../_common/redux/addons/actions'
import {
  FETCH_INVENTORY_DELEGATIONS,
  CREATE_INVENTORY_DELEGATION,
  DELETE_INVENTORY_DELEGATION,
  UPDATE_INVENTORY_DELEGATION,
  UPDATE_INVENTORY_DELEGATION_TYPE,
} from '../../_common/redux/inventorydelegations/actions'
import { CARD_STATUS_UNCHANGED, CARD_STATUS_CHANGED, CARD_STATUS_SAVED } from '../../_common/core/form_helper'
import { getGroupedTickets } from '../utils/ticketUtils'

import {
  get_event,
  get_event_tickets,
  get_event_tables,
  get_event_addons,
  get_event_inventorydelegations,
} from '../../_common/core/selectors'
import { showAxiosError, showMessage, showSuccessMessage } from '../utils/messenger'
import { getTitle } from '../utils/getTitle'
import { reserveSeatsIo } from '../../_common/core/http_services/seatsio'
import { GuestTicketFormContainer } from './ticket/TicketGuestFormSection/GuestTicketForm'
import { GuestTicketTopCustomerFormContainer } from './ticket/TicketGuestFormSection/GuestTicketTopCustomer'
import { baseRequest } from '../../_common/core/http_services'

function getTicketTypeID(ticketTypeName, tickets) {
  const ticketType = _find(
    tickets,
    ticket => ticket.displayName.toLowerCase() === ticketTypeName.toLowerCase(),
  )
  return ticketType?.id
}

function getTicketAddOns(ticketAddOns) {
  const addOns = []

  if (ticketAddOns) {
    ticketAddOns.forEach(addOn => {
      addOns.push({
        quantity: 1,
        id: addOn.id,
      })
    })
  }

  return addOns
}

function getUploadCSVTicketHolders(recipient, quantity) {
  const ticketHolders = []

  for (let i = 0; i < quantity; i++) {
    ticketHolders.push({
      first_name: recipient.first_name,
      last_name: recipient.last_name,
      email: recipient.email,
      add_ons: getTicketAddOns(recipient.ticketAddOns),
    })
  }

  return ticketHolders
}

function getUploadCSVTicketHoldersCRM(recipient, quantity) {
  const ticketHolders = []

  for (let i = 0; i < quantity; i++) {
    ticketHolders.push({
      first_name: recipient.firstName,
      last_name: recipient.lastName,
      email: recipient.email,
      add_ons: getTicketAddOns(recipient.ticketAddOns),
    })
  }

  return ticketHolders
}

@withRouter
@connect(
  state => {
    const event = get_event(state)
    const tickets = get_event_tickets(state)
    const tables = get_event_tables(state)
    const addons = get_event_addons(state)
    const inventoryDelegations = get_event_inventorydelegations(state)

    let seatData = null
    const stateEventId = state.guesttickets.eid
    const eid = event.id
    const { seatDataChecked, ticketTypes } = state.guesttickets
    const { statuses } = state.guesttickets
    const reservation_eid = state.guesttickets.eid

    if (stateEventId === eid) {
      // eslint-disable-next-line prefer-destructuring
      seatData = state.guesttickets.seatData
    }

    return {
      user: state.auth.user,
      event,
      reservation_eid,
      tickets,
      tables,
      addons,
      inventoryDelegations,
      inventoryDelegationsLoading: state.loading.has('FETCH_INVENTORY_DELEGATIONS'),
      seatData,
      seatDataChecked,
      getSeatDataLoading: state.loading.has('GET_SEAT_MAP_DATA'),
      statuses,
      getSeatDataStatusesLoading: state.loading.has('GET_SEAT_MAP_STATUSES'),
      ticketTypes,
    }
  },
  {
    FETCH_EVENT_TICKETS,
    FETCH_EVENT_TABLES,
    GET_SEAT_MAP_DATA,
    UPLOAD_GUESTTICKETS,
    FETCH_EVENT_ADDONS,
    FETCH_INVENTORY_DELEGATIONS,
    CREATE_INVENTORY_DELEGATION,
    DELETE_INVENTORY_DELEGATION,
    UPDATE_INVENTORY_DELEGATION,
    UPDATE_INVENTORY_DELEGATION_TYPE,
  },
)
export default class EventGuestTickets extends React.Component {
  constructor(props) {
    super(props)
    form_helper_reset()
    this.mounted = false
    this.cardsStatusForm = {
      form: CARD_STATUS_UNCHANGED,
    }
    this.cardsStatusCSV = {
      form: CARD_STATUS_UNCHANGED,
    }
    this.createNewDelegation = this.createNewDelegation.bind(this)
    this.deleteDelegation = this.deleteDelegation.bind(this)
    this.updateDelegation = this.updateDelegation.bind(this)
    this.updateDelegationType = this.updateDelegationType.bind(this)
    this.uploadGuestsFromForm = this.uploadGuestsFromForm.bind(this)
    this.uploadGuestsFromCSV = this.uploadGuestsFromCSV.bind(this)
    this.uploadGuestsFromTopCustomers = this.uploadGuestsFromTopCustomers.bind(this)
    this.GuestTicketsIssued = createRef()
  }
  componentDidMount() {
    Messenger.options = {
      extraClasses: 'messenger-fixed messenger-on-top messenger-on-right',
      theme: 'future',
    }

    const {
      event: { id, flagSeatMapAllowed, displayName },
      reservation_eid,
      FETCH_EVENT_TICKETS,
      FETCH_EVENT_TABLES,
      FETCH_EVENT_ADDONS,
      FETCH_INVENTORY_DELEGATIONS,
      GET_SEAT_MAP_DATA,
      configs,
    } = this.props

    const configDocTitle = _get(configs, 'messages.documentTitle', '')
    document.title = getTitle(configDocTitle, [displayName])

    Promise.resolve(FETCH_EVENT_TICKETS(id)).catch()
    Promise.resolve(FETCH_EVENT_ADDONS(id)).catch()
    Promise.resolve(FETCH_EVENT_TABLES(id)).catch()

    this.mounted = true

    FETCH_INVENTORY_DELEGATIONS(id)
    if (flagSeatMapAllowed) {
      if (+id !== +reservation_eid) {
        GET_SEAT_MAP_DATA(id).catch(() => {})
      }
    }
  }

  componentWillUnmount() {
    form_helper_reset()
    this.mounted = false
  }

  routerWillLeave = () => !form_helper_isEditted()

  async uploadGuestsFromForm(form, isSeatMap, isSeatsIo, selectedTab, seatsIoActiveId) {
    const { event, UPLOAD_GUESTTICKETS, FETCH_EVENT_TICKETS } = this.props
    if (isSeatsIo && selectedTab === 'ticketsOnMap') {
      try {
        const seats = form.seat_io_tickets.map(ticket => ({
          ticketTypeId: ticket.ticketTypeId,
          label: ticket.seatsIoLabel,
        }))
        await reserveSeatsIo(event.id, seats, seatsIoActiveId ?? 'main')
        const recipients = form.seat_io_tickets.reduce((curr, item) => {
          const index = curr.findIndex(ticket => ticket.ticketTypeID === item.ticketTypeId)
          if (index !== -1) {
            curr[index].ticketHolders.push({
              first_name: item.first_name,
              last_name: item.last_name,
              add_ons: item.add_ons,
            })
            curr[index].seats_io_seats = curr[index].seats_io_seats + ',' + item.seats_io_seats
            curr[index].quantity += 1
          } else {
            curr.push({
              first_name: item.first_name,
              last_name: item.last_name,
              email: form.email,
              ticketTypeID: item.ticketTypeId,
              quantity: 1,
              ticketHolders: [
                { first_name: item.first_name, last_name: item.last_name, add_ons: item.add_ons },
              ],
              seats_io_event_id: item.seats_io_event_id,
              seats_io_seats: item.seats_io_seats,
            })
          }
          return curr
        }, [])
        await UPLOAD_GUESTTICKETS(event.id, recipients)
        showSuccessMessage('Successfully Uploaded!')
        form_helper_reset()
        this.changeFormCardStatusToNormal()
        setTimeout(() => {
          this.GuestTicketsIssued?.current?.manualRefresh()
        }, 4000)
        return
      } catch (e) {
        showAxiosError(e)
        throw e
      }
    }
    try {
      const recipients = [
        {
          first_name: form.ticketHolders[0].first_name,
          last_name: form.ticketHolders[0].last_name,
          email: form.email,
          ticketTypeID: form.ticketTypeID || form.tableTypeID,
          tableTypeID: form.tableTypeID,
          quantity: form.quantity,
          ticketHolders: form.ticketHolders,
          notes: form.notes,
          tags: form.tags,
          reservation_id: localStorage.getItem('reservationId'),
        },
      ]
      await UPLOAD_GUESTTICKETS(event.id, recipients, isSeatMap, form.flagOverrideStock)
      showSuccessMessage('Successfully Uploaded!')
      form_helper_reset()
      this.changeFormCardStatusToNormal()
      setTimeout(() => {
        this.GuestTicketsIssued?.current?.manualRefresh()
      }, 4000)
      await FETCH_EVENT_TICKETS(event.id)
      return
    } catch (e) {
      throw e
    }
  }

  uploadGuestsFromCSV(data) {
    const { event, UPLOAD_GUESTTICKETS, tickets, tables, FETCH_EVENT_TICKETS } = this.props
    const recipients = _map(data.recipients, recipient => ({
      first_name: recipient.first_name,
      last_name: recipient.last_name,
      email: recipient.email,
      ticketTypeID: recipient.time || getTicketTypeID(recipient.ticketTypeName, tickets.concat(tables)),
      quantity: parseInt(recipient.quantity),
      notes: recipient.notes,
      ticketHolders: getUploadCSVTicketHolders(recipient, parseInt(recipient.quantity)),
      tags: recipient.tags,
    }))
    return Promise.resolve(UPLOAD_GUESTTICKETS(event.id, recipients))
      .catch(err => {
        showAxiosError(err, err)
        return Promise.reject(_result(err, 'toFieldErrors', err))
      })
      .then(v => {
        Promise.resolve(FETCH_EVENT_TICKETS(event.id)).catch()
        showMessage('success', 'Successfully Uploaded!', 10, true)
        form_helper_reset()
        this.changeCSVCardStatusToNormal()
        setTimeout(() => {
          this.GuestTicketsIssued?.current?.manualRefresh()
        }, 4000)
        return v
      })
  }

  async uploadGuestsFromTopCustomers(data) {
    const { event, UPLOAD_GUESTTICKETS, tickets, tables } = this.props

    if (data.quantityTopCustomers === 'all') {
      try {
        await baseRequest.post('guest_tickets_opt_ins', {
          ticketTypeID: data.defaultTicketTypeID,
          quantity: data.defaultTicketQuantity,
          flagOverrideStock: false,
          flagGeneratedList: true,
          relationships: {
            event: {
              data: {
                id: event.id,
                type: 'event',
              },
            },
          },
        })
        showMessage('success', 'Successfully Uploaded!', 10, true)
        form_helper_reset()
        this.changeCSVCardStatusToNormal()
        setTimeout(() => {
          this.GuestTicketsIssued?.current?.manualRefresh()
        }, 4000)
        return
      } catch (err) {
        showAxiosError(err, err)
        return
      }
    }

    const recipients = _map(data.recipients, recipient => ({
      first_name: recipient.firstName,
      last_name: recipient.lastName,
      email: recipient.email,
      ticketTypeID: recipient.time || getTicketTypeID(recipient.ticketTypeName, tickets.concat(tables)),
      quantity: parseInt(recipient.quantity),
      notes: recipient.notes,
      ticketHolders: getUploadCSVTicketHoldersCRM(recipient, parseInt(recipient.quantity)),
      tags: recipient.tags,
    }))
    try {
      await UPLOAD_GUESTTICKETS(event.id, recipients, undefined, undefined, true)
      showMessage('success', 'Successfully Uploaded!', 10, true)
      form_helper_reset()
      this.changeCSVCardStatusToNormal()
      setTimeout(() => {
        this.GuestTicketsIssued?.current?.manualRefresh()
      }, 4000)
    } catch (err) {
      showAxiosError(err, err)
    }
  }

  changeFormCardStatusToNormal() {
    const that = this
    if (this.cardsStatusForm.form !== CARD_STATUS_UNCHANGED) {
      this.cardsStatusForm.form = CARD_STATUS_SAVED
      setTimeout(() => {
        that.cardsStatusForm.form = CARD_STATUS_UNCHANGED
        that.forceUpdate()
      }, 3000)
    }
    this.forceUpdate()
  }

  changeCSVCardStatusToNormal() {
    const that = this
    if (this.cardsStatusCSV.form !== CARD_STATUS_UNCHANGED) {
      this.cardsStatusCSV.form = CARD_STATUS_SAVED
      setTimeout(() => {
        that.cardsStatusCSV.form = CARD_STATUS_UNCHANGED
        that.forceUpdate()
      }, 3000)
    }
    this.forceUpdate()
  }

  createNewDelegation(data) {
    const { event, CREATE_INVENTORY_DELEGATION } = this.props
    return CREATE_INVENTORY_DELEGATION(event.id, data)
  }

  deleteDelegation(did) {
    const { event, DELETE_INVENTORY_DELEGATION } = this.props
    return DELETE_INVENTORY_DELEGATION(did, event.id)
  }

  updateDelegation(did, data) {
    const { event, UPDATE_INVENTORY_DELEGATION } = this.props
    return UPDATE_INVENTORY_DELEGATION(did, event.id, data)
  }
  updateDelegationType(did, data) {
    const { event, UPDATE_INVENTORY_DELEGATION_TYPE, FETCH_INVENTORY_DELEGATIONS } = this.props
    return Promise.resolve(UPDATE_INVENTORY_DELEGATION_TYPE(did, event.id, data))
      .catch(err => Promise.reject(_result(err, 'toFieldErrors', err)))
      .then(async v => {
        FETCH_INVENTORY_DELEGATIONS(event.id)
        return v
      })
  }
  render() {
    const {
      user,
      event,
      tickets,
      tables,
      addons,
      inventoryDelegations,
      inventoryDelegationsLoading,
      seatData,
      seatDataChecked,
      statuses,
      getSeatDataLoading,
      getSeatDataStatusesLoading,
      configs,
      ticketTypes,
    } = this.props
    const { flagTimeSlotsEnabled, flagSeatMapAllowed } = event

    const [normalTickets, groupedTickets] = ticketTypesSorting(tickets)

    const contentEditedFields = []

    let ticketHolders = false
    let recipients = false
    const tags = false
    Object.keys(form_helper_get()).forEach((field, index) => {
      if (field === 'ticketTypeID') {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> Ticket Type
          </div>,
        )
        this.cardsStatusForm.form = CARD_STATUS_CHANGED
      } else if (field === 'quantity') {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> Quantity
          </div>,
        )
        this.cardsStatusForm.form = CARD_STATUS_CHANGED
      } else if (field === 'email') {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> Email
          </div>,
        )
        this.cardsStatusForm.form = CARD_STATUS_CHANGED
      } else if (field === 'first_name') {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> First Name
          </div>,
        )
        this.cardsStatusForm.form = CARD_STATUS_CHANGED
      } else if (field === 'last_name') {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> Last Name
          </div>,
        )
        this.cardsStatusForm.form = CARD_STATUS_CHANGED
      } else if (field === 'notes') {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> Notes
          </div>,
        )
        this.cardsStatusForm.form = CARD_STATUS_CHANGED
      } else if (field.startsWith('ticketHolders')) {
        // let fieldS = field.split('[')[1].split('].')
        // contentEditedFields.push(<div key={field}> - Ticket Holder #{parseInt(fieldS[0])+1}
        // {fieldS[1]=='first_name' ? 'First Name':'Last Name'}</div>)
        if (!ticketHolders) {
          contentEditedFields.push(
            <div key={field}>
              <i className="fa fa-info-circle" aria-hidden="true" /> Ticket Holders
            </div>,
          )
          ticketHolders = true
          this.cardsStatusForm.form = CARD_STATUS_CHANGED
        }
      } else if (field.startsWith('tags')) {
        if (!tags) {
          contentEditedFields.push(
            <div key={field}>
              <i className="fa fa-info-circle" aria-hidden="true" /> Tags
            </div>,
          )
          this.cardsStatusCSV.form = CARD_STATUS_CHANGED
        }
      } else if (field.startsWith('recipients[')) {
        if (!recipients) {
          contentEditedFields.push(
            <div key={field}>
              <i className="fa fa-info-circle" aria-hidden="true" /> Recipients from CSV
            </div>,
          )
          recipients = true
          this.cardsStatusCSV.form = CARD_STATUS_CHANGED
        }
      } else {
        contentEditedFields.push(
          <div key={field}>
            <i className="fa fa-info-circle" aria-hidden="true" /> {field}
          </div>,
        )
      }
    })

    return (
      <DisableSectionByPermissionWrapper>
        <div className="EventGuestTickets">
          <RouteLeavingGuard routerWillLeave={this.routerWillLeave} />
          <Card
            title={'Send Guest Tickets'}
            className="guest-ticket-form"
            status={this.cardsStatusForm && this.cardsStatusForm.form}
          >
            <GuestTicketFormContainer
              event={event}
              seatData={seatData}
              statuses={statuses}
              seatDataChecked={flagSeatMapAllowed ? seatDataChecked : true}
              getSeatDataLoading={flagSeatMapAllowed ? getSeatDataLoading : false}
              getSeatDataStatusesLoading={getSeatDataStatusesLoading}
              tickets={getGroupedTickets(tickets)}
              tables={tables}
              onSubmit={this.uploadGuestsFromForm}
              cardsStatus={this.cardsStatusForm}
              addons={addons}
              ticketTypes={ticketTypes}
              user={user}
            />
          </Card>
          {(!!normalTickets.length || !!tables.length) && (
            <ImportGuestsForm
              event={event}
              tickets={normalTickets}
              tables={tables}
              addons={addons}
              onSubmit={this.uploadGuestsFromCSV}
              cardsStatus={this.cardsStatusCSV}
            />
          )}
          {event.flagAllowGuestTicketsByTopCustomers ||
          event.flagAllowGuestTicketsByOptIns ||
          user.tfStaff ? (
            <GuestTicketTopCustomerFormContainer
              event={event}
              seatData={seatData}
              statuses={statuses}
              seatDataChecked={flagSeatMapAllowed ? seatDataChecked : true}
              getSeatDataLoading={flagSeatMapAllowed ? getSeatDataLoading : false}
              getSeatDataStatusesLoading={getSeatDataStatusesLoading}
              normalTickets={normalTickets}
              tickets={getGroupedTickets(tickets)}
              tables={tables}
              onSubmit={this.uploadGuestsFromTopCustomers}
              cardsStatus={this.cardsStatusForm}
              addons={addons}
              ticketTypes={ticketTypes}
              user={user}
            />
          ) : null}
          {flagTimeSlotsEnabled && !!groupedTickets.length && (
            <TimeSlotGuestsForm
              event={event}
              tickets={groupedTickets}
              onSubmit={this.uploadGuestsFromCSV}
              cardsStatus={this.cardsStatusCSV}
            />
          )}
          <Card title={'Issued Guest Tickets'}>
            <GuestTicketsIssued refIssued={this.GuestTicketsIssued} event={event} />
          </Card>
        </div>
      </DisableSectionByPermissionWrapper>
    )
  }
}
